// Pattern: docs/design-patterns/frontend-form-handling
// Signup schema with confirm-password cross-field validation

import { z } from 'zod';

import { createPasswordSchema } from '../../config/password-schema';

export const signupSchema = z
  .object({
    email: z.string().email('Please enter a valid email address'),
    password: createPasswordSchema(),
    confirmPassword: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      });
    }
  });

export type SignupFormData = z.infer<typeof signupSchema>;
